module.exports = __webpack_public_path__ + "assets/gcp.0dafcbf6.svg";